// extracted by mini-css-extract-plugin
export default {"ColorTypeValue":"ColorTypeValuelgl_m","colorTypeValue":"ColorTypeValuelgl_m"};